import { render, staticRenderFns } from "./ExpiredSession.vue?vue&type=template&id=4bf2d73d"
import script from "./ExpiredSession.vue?vue&type=script&lang=js"
export * from "./ExpiredSession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports